import React, { useState, useEffect } from 'react';
import { getExpressParams, postExpress, putExpress, deleteExpressParams } from '../../../service/api';
import NoiseFilterManagerMain from '../../presentation/section/admin-page/NoiseFilterManagerMain';

const NoiseFilterManager = () => {
  const [currentNoiseFilter, setCurrentNoiseFilter] = useState({
    active: 0,
    basicFilter: "",
    booleanFilter: "",
    category: "",
    filterID: null
  });

  const [noiseFilterArray, setNoiseFilterArray] = useState([]);

  // 추가 모달 상태
  const [showAddModal, setShowAddModal] = useState(false);
  const [newCategory, setNewCategory] = useState("");
  const [newBasicFilter, setNewBasicFilter] = useState("");

  // 편집 모드 상태
  const [isEditing, setIsEditing] = useState(false);
  const [editCategory, setEditCategory] = useState("");
  const [editBasicFilter, setEditBasicFilter] = useState("");

  const fetchNoiseFilters = () => {
    getExpressParams('/query/noisefilter/all', {}, (response) => {
      setNoiseFilterArray(response.data);
    });
  };

  useEffect(() => {
    fetchNoiseFilters();
  }, []);

  const selectNoiseFilter = (item) => {
    setCurrentNoiseFilter(item);
    setIsEditing(false);
  };

  // basicFilter → booleanFilter 변환
  // basicFilter: "aaa, bbb, ccc" → booleanFilter: "! aaa ! bbb ! ccc"
  const convertBasicToBoolean = (basicFilter) => {
    if (!basicFilter || basicFilter.trim() === "") return "";
    const words = basicFilter.split(",").map(w => w.trim()).filter(w => w !== "");
    return words.map(w => `! ${w}`).join(" ");
  };

  // 추가 모달 핸들러
  const handleShowAddModal = () => setShowAddModal(true);
  const handleCancelAddModal = () => {
    setNewCategory("");
    setNewBasicFilter("");
    setShowAddModal(false);
  };

  const handleAddFilter = () => {
    if (!newCategory.trim()) {
      alert("카테고리(제목)를 입력해주세요.");
      return;
    }
    const booleanFilter = convertBasicToBoolean(newBasicFilter);
    postExpress('/query/noisefilter', {
      category: newCategory.trim(),
      basicFilter: newBasicFilter.trim(),
      booleanFilter: booleanFilter
    }, (response) => {
      if (response.data.success) {
        fetchNoiseFilters();
        handleCancelAddModal();
      }
    });
  };

  // 활성화/비활성화
  const handleActivate = () => {
    if (!currentNoiseFilter.filterID) return;
    putExpress('/query/noisefilter/active', {
      filterID: currentNoiseFilter.filterID,
      active: 1
    }, (response) => {
      if (response.data.success) {
        setCurrentNoiseFilter({ ...currentNoiseFilter, active: 1 });
        fetchNoiseFilters();
      }
    });
  };

  const handleDeactivate = () => {
    if (!currentNoiseFilter.filterID) return;
    putExpress('/query/noisefilter/active', {
      filterID: currentNoiseFilter.filterID,
      active: 0
    }, (response) => {
      if (response.data.success) {
        setCurrentNoiseFilter({ ...currentNoiseFilter, active: 0 });
        fetchNoiseFilters();
      }
    });
  };

  // 편집 모드 시작
  const handleStartEdit = () => {
    setEditCategory(currentNoiseFilter.category || "");
    setEditBasicFilter(currentNoiseFilter.basicFilter || "");
    setIsEditing(true);
  };

  // 편집 저장
  const handleSaveEdit = () => {
    const booleanFilter = convertBasicToBoolean(editBasicFilter);
    putExpress('/query/noisefilter/edit', {
      filterID: currentNoiseFilter.filterID,
      category: editCategory.trim(),
      basicFilter: editBasicFilter.trim(),
      booleanFilter: booleanFilter
    }, (response) => {
      if (response.data.success) {
        const updated = {
          ...currentNoiseFilter,
          category: editCategory.trim(),
          basicFilter: editBasicFilter.trim(),
          booleanFilter: booleanFilter
        };
        setCurrentNoiseFilter(updated);
        setIsEditing(false);
        fetchNoiseFilters();
      }
    });
  };

  // 편집 취소
  const handleCancelEdit = () => {
    setIsEditing(false);
  };

  // 삭제
  const handleDelete = () => {
    if (!currentNoiseFilter.filterID) return;
    if (!window.confirm(`"${currentNoiseFilter.category}" 필터를 삭제하시겠습니까?`)) return;
    deleteExpressParams('/query/noisefilter', {
      filterID: currentNoiseFilter.filterID,
      category: currentNoiseFilter.category
    }, (response) => {
      if (response.data.success) {
        setCurrentNoiseFilter({
          active: 0,
          basicFilter: "",
          booleanFilter: "",
          category: "",
          filterID: null
        });
        fetchNoiseFilters();
      }
    });
  };

  return (
    <NoiseFilterManagerMain
      noiseFilterArray={noiseFilterArray}
      currentNoiseFilter={currentNoiseFilter}
      selectNoiseFilter={selectNoiseFilter}
      // 추가 모달
      showAddModal={showAddModal}
      handleShowAddModal={handleShowAddModal}
      handleCancelAddModal={handleCancelAddModal}
      newCategory={newCategory}
      setNewCategory={setNewCategory}
      newBasicFilter={newBasicFilter}
      setNewBasicFilter={setNewBasicFilter}
      handleAddFilter={handleAddFilter}
      // 활성화/비활성화
      handleActivate={handleActivate}
      handleDeactivate={handleDeactivate}
      // 편집
      isEditing={isEditing}
      handleStartEdit={handleStartEdit}
      handleSaveEdit={handleSaveEdit}
      handleCancelEdit={handleCancelEdit}
      editCategory={editCategory}
      setEditCategory={setEditCategory}
      editBasicFilter={editBasicFilter}
      setEditBasicFilter={setEditBasicFilter}
      // 삭제
      handleDelete={handleDelete}
    />
  );
};

export default NoiseFilterManager;
